/*
Replace
timeslot with your resource Name :) Take care about different writings!
/!\ Timeslot timeslot Timeslots timeslots /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const timeslotSlice = createSlice({
  name: "timeslots",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listTimeslots,
  show: showTimeslot,
  create: createTimeslot,
  update: updateTimeslot,
} = timeslotSlice.actions;

export const actions = timeslotSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const timeslots = (state) =>
  state.timeslots.idsList.map((id) => state.timeslots.dictionary[id]);
export const timeslot = (state) =>
  state.timeslots.showId && state.timeslots.dictionary[state.timeslots.showId];
export const timeslotAttributes = (state) => timeslot(state)?.attributes;
export const timeslotRelationships = (state) => timeslot(state)?.relationships;
export const timeslotId = (state) => state.timeslots.showId;

export const getTimeslot = createSelector(
  (state) => state.timeslots.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getTimeslotAttributes = createSelector(
  (state) => state.timeslots.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getTimeslotRelationships = createSelector(
  (state) => state.timeslots.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getTimeslots = createSelector(
  (state) => state.timeslots.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default timeslotSlice.reducer;
